/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDRadiusDownLeftIcon16Solid = forwardRef('ArrowDRadiusDownLeftIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M12.75 3A4.75 4.75 0 0 1 8 7.75H4.518l2.366-2.366a1.25 1.25 0 0 0-1.768-1.768L1.465 7.268a2.45 2.45 0 0 0 0 3.464l3.651 3.652a1.25 1.25 0 0 0 1.768-1.768L4.518 10.25H8A7.25 7.25 0 0 0 15.25 3a1.25 1.25 0 1 0-2.5 0Z" })));
});
